import { useNavigate, useParams } from "react-router-dom";

import TituloForm, { ITituloFormProps } from "./TituloForm";

export interface ITituloAReceberScreenProps extends ITituloFormProps {
    // defaultValues?: Titulo,
    // disable?: React.ComponentProps<typeof TituloForm>["disable"];
    // rateioFormProps?: React.ComponentProps<typeof TituloForm>["rateioFormProps"];
}

export default function TituloAReceberScreen({ onCancelar, onSalvarSucesso, codigo : codParam, ...rest }: ITituloAReceberScreenProps): JSX.Element {
    const navigate = useNavigate();
    
    const { codigo : codRotaString } = useParams();
    const codRota = Number.parseInt(codRotaString ?? "");

    const codigo = isNaN(codRota) || codRota <= 0 ? codParam : codRota;
    
    const isAlteracao = (codigo ?? 0) > 0;

    return (
        <TituloForm
            {...rest}
            codigo={codigo}
            isAReceber={isAlteracao ? undefined : true}
            onCancelar={onCancelar ?? ((ev) => navigate(-1))}
            onSalvarSucesso={(...rest) => {
                onSalvarSucesso?.(...rest);
                (onCancelar ?? ((ev) => navigate(-1)))?.({} as any);
            }}
        />
    );
}